type LogoProps = {
  className?: string;
};

export const Logo = ({ className = "" }: LogoProps) => (
  <>
    <img
      src="/logo-dark.avif"
      alt="Nordex"
      width={97}
      height={16}
      loading="eager"
      decoding="sync"
      fetchPriority="high"
      className={`hidden dark:block h-auto ${className}`}
    />
    <img
      src="/logo-light.avif"
      alt="Nordex"
      width={97}
      height={16}
      loading="eager"
      decoding="sync"
      fetchPriority="high"
      className={`block dark:hidden h-auto ${className}`}
    />
  </>
);
